/**
 * Tutorial reference: https://www.youtube.com/watch?v=baLjPx_wFi4
 */
import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

let REACT_APP_URL = "http://localhost:3000";
if (window.location.host !== "localhost:8000") {
  REACT_APP_URL = window.location.origin;
}

if(window.location.host === "chc.stage.nixa.ca") {
    REACT_APP_URL = "/static";
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `${REACT_APP_URL}/assets/i18n/{{ns}}/{{lng}}.json`,
    },
    fallbackLng: "en",
    // Debugger disable in production
    debug: false,
    // Can have multiple namespaces
    ns: ["home", "common", "form", "profile", "validation", "visits", "firebaseError"],
    supportedLngs: ["en", "fr"],
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    react: {
      wait: true,
      useSuspense: true,
    },
  });

export default i18n;
